import { StyledLabelOffBox, StyledLabelText } from './style';

export const StateLabelOffBox = () => (
  <StyledLabelOffBox>
    <StyledLabelText>Off</StyledLabelText>
  </StyledLabelOffBox>
);
